import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Tooltip — Radix's, wrapped.
 *
 * WCAG 2.2 1.4.13 asks three things of content that appears on hover: it can be dismissed with
 * Escape without moving the pointer, the pointer can move onto it without it vanishing, and it
 * stays until it is dismissed or stops being relevant. Radix does all three, and this wrapper does
 * not switch any of them off.
 *
 * A tooltip is never the only place something is said. It supplements a control that already has
 * an accessible name; it is not a way to give one to a nameless icon button — use `label` on
 * Button for that.
 */
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { cx } from '../lib/cx.js';
import { usePortalContainer } from '../theme/theme-provider.js';
/** Wrap the app once so tooltips share one delay and one "skip the delay" window. */
export const TooltipProvider = RadixTooltip.Provider;
export function Tooltip({ content, side = 'top', delayMs = 300, open, defaultOpen, onOpenChange, className, children, }) {
    const container = usePortalContainer();
    return (_jsxs(RadixTooltip.Root, { delayDuration: delayMs, open: open, defaultOpen: defaultOpen, onOpenChange: onOpenChange, children: [_jsx(RadixTooltip.Trigger, { asChild: true, children: children }), _jsx(RadixTooltip.Portal, { container: container, children: _jsxs(RadixTooltip.Content, { className: cx('clav-tooltip__content', className), side: side, sideOffset: 6, collisionPadding: 8, children: [content, _jsx(RadixTooltip.Arrow, { className: "clav-tooltip__arrow" })] }) })] }));
}
//# sourceMappingURL=tooltip.js.map